<script setup>
import { ref } from "vue";
import { getRequest, postRequest, putRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
const emit = defineEmits(["ok"]);
const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);
const formModel = ref({});
const formRef = ref();


const rules = reactive({
  title: [
    {
      required: true,
      message: "标题",
      trigger: "blur",
    },
  ],
  name: [
    {
      required: true,
      message: "请输入职位名称",
      trigger: "blur",
    },
  ],
  phone: [
    {
      required: true,
      message: "请输入联系电话",
      trigger: "blur",
    },
  ],
  headcount: [
    {
      required: true,
      message: "请选择招聘人数",
      trigger: "blur",
    },
  ],

});



const handleEdit = (record) => {
  formModel.value = Object.assign({}, { ...record });
  open.value = true;
};



const handleClose = () => {
  open.value = false;
  formRef.value.resetFields();

};

const handleConfirm = async () => {
  formRef.value.validate().then(async () => {
    const unrefFormModel = unref(formModel);
    let request;
    if (unrefFormModel.id) {
      request = putRequest;
    } else {
      request = postRequest;
    }
    request("/job", unrefFormModel).then((response) => {
      if (response.success) {
        message.success("保存成功");
        emit("ok");
        handleClose();
      } else {
        message.error("保存失败。" + response.message);
      }
    });
  });
};


defineExpose({
  handleEdit,
  handleClose,
});
</script>


<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form
      ref="formRef"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 24 }"
      :model="formModel"
      :rules="rules"
    >
      <a-form-item label="标题" name="title">
        <a-input
          v-model:value="formModel.title"
          autocomplete="off"
          placeholder="请输入标题"
        />
      </a-form-item>
      <a-form-item label="职位名称" name="name">
        <a-input v-model:value="formModel.name" placeholder="请职位名称" />
      </a-form-item>
	  <a-form-item label="电话" name="phone">
	    <a-input
	      v-model:value="formModel.phone"
	      :placeholder="
	        formModel.oldPhone ? `电话：${formModel.oldPhone}` : '请输入电话'
	      "
	    />
	  </a-form-item>
            <a-form-item label="招聘人数" name="jobSeekerStatus">
              <a-select
                v-model:value="formModel.headcount"
                placeholder="请选择求招聘人数"
              >
                <a-select-option value="1-2人">1-2人</a-select-option>
                <a-select-option value="3-5人">3-5人</a-select-option>
                <a-select-option value="6-10人">6-10人</a-select-option>
                <a-select-option value="11-20人">11-20人</a-select-option>
				<a-select-option value="20人以上">20人以上</a-select-option>
              </a-select>
            </a-form-item>

    </a-form>
  </a-modal>
</template>



<style scoped lang="scss"></style>
